module.exports = __webpack_public_path__ + "static/media/Niveau_elN9_4_699031.2ad6bb39.png";